var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.formData.title,
            visible: _vm.drawer,
            direction: _vm.direction,
            modal: true,
            "append-to-body": true,
            "wrapper-closable": false,
            "before-close": _vm.handleClose,
            size: _vm.formData.width,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("oaForm", {
            ref: "oaForm",
            attrs: { "form-info": _vm.fromInfo, btnShow: false },
            on: { handleClose: _vm.handleClose, submitOk: _vm.submitOk },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }